import fetchUserPreferences from './fetch-user-preferences';

export default {
  fetchUserPreferences,
};
